<template>
  <div
    style="backgroundImage: url(./img/wixbackground.png); background-size: cover; min-height: calc(100vh - 66px); padding-top: 120px;"
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-35 md-small-hide" />
      <div
        class="md-layout-item md-size-30 md-small-size-100 md-card"
        style="text-align: center; background-color: white; padding-left: 60px; padding-right: 70px; margin-bottom: 20px;"
      >
        <div style="text-align: center">
          <div
            slot="title"
            class="title"
            style="font-family: 'Roboto'; color:black;font-size: xxx-large;padding-top: 30px; padding-bottom: 20px;"
          >
            {{ $t("Log In") }}
          </div>
          <h4
            slot="title"
            class="title"
            style="font-family: 'Roboto'; color:darkslateblue"
          >
            Welcome to RPAS WILCO
          </h4>
        </div>
        <br />
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>{{ $t("Email") }}...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>{{ $t("Password") }}...</label>
          <md-input
            v-model="password"
            type="password"
            @keyup="keymonitor"
          ></md-input>
        </md-field>
        <br />
        <md-button slot="footer" class="md-primary md-block" @click="logon">{{
          $t("Log In")
        }}</md-button>
        <br />
        <md-button
          slot="footer"
          class="md-sm md-primary md-block"
          @click="forgotpassword"
          >{{ $t("Forgot Password") }}</md-button
        >

        <br />
        <label class="text-danger">{{ $t(errorMsg) }}</label>
        <br />
        <br />
        <br />
      </div>
      <!-- <div class="md-layout-item md-size-15 md-small-hide"></div> -->
      <div class="md-layout-item md-size-35 md-small-hide"></div>
    </div>
  </div>
</template>
<script>
import { EventBus } from "@/helpers";

export default {
  name: "login",
  bodyClass: "index-page",
  props: {
    logoImg: {
      type: String,
      default: "./img/logo-inverted.png"
    },
    img: {
      type: String,
      default: "./img/default-avatar.png"
    }
  },
  data() {
    return {
      email: null,
      password: null,
      errorMsg: "",
      scrollPosition: null,
      mobilescreen: false
    };
  },
  computed: {
    setHeaderBgImage() {
      return {
        backgroundImage: `url(./img/background2x2.jpg)`
      };
    },
    setContactUsBgImage() {
      return {
        backgroundImage: `url(./img/bg-contactus.jpg)`
      };
    }
  },
  methods: {
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = true;
      }
    },
    keymonitor(event) {
      if (event.key === "Enter") {
        this.logon();
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    logon() {
      this.$store.dispatch("auth/logon", {
        email: this.email,
        password: this.password
      });
    },
    forgotpassword() {
      this.$router.push("/forgotpassword");
    },
    onResponsiveInverted() {
      if (window.innerWidth < 800) {
        this.mobilescreen = true;
      } else {
        this.mobilescreen = false;
      }
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
    document.addEventListener("scroll", this.updateScroll);
    EventBus.$on("failedLogon", msg => {
      this.errorMsg = msg;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
    document.removeEventListener("scroll", this.updateScroll);
    EventBus.$off("failedLogon");
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

.vertical-nav-active {
  display: block;
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
@media all and (max-width: 768px) {
  .vertical-nav-active {
    display: none;
  }
}

.mb-0 {
  padding-bottom: 0 !important;
}

#morphing-cards {
  padding-top: 70px;
}

.cd-section {
  height: 100vh;
}
.md-toolbar {
  background-color: rgba(0, 0, 0, 0.5);
}
.main-toolbar {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
}
@media all and (min-width: 991px) {
  .hamburger {
    display: none;
  }
}
@media all and (max-width: 768px) {
  .main-toolbar {
    background-color: white;
  }
}
</style>
